import type { FunctionComponent } from "react";
import { DialogContent, DialogHeader } from "../../../../components/ui/dialog";
import { useToast } from "../../../../hooks/use-toast";

import Spinner from "../../../../components/spinner.components";
import { useFinaliseDmsCostAdminHttp } from "../../../../hooks/http/admin/campaigns/finalise-dms-cost.admin.http";
import { useNavigate, useParams } from "react-router-dom";
import { handleHttpError } from "../../../../utils/utils";
import { Button } from "../../../../components/ui/button";
import { DialogClose } from "@radix-ui/react-dialog";

export const FinalizeDMSCostModalPartial: FunctionComponent = () => {
	const { execute: finaliseCostHttp, fetching: finalisingCost } =
		useFinaliseDmsCostAdminHttp();
	const { toast } = useToast();

	const { campaignId } = useParams();

	const navigate = useNavigate();

	async function finalizeDMSCost() {
		if (!campaignId) {
			return;
		}
		const response = await finaliseCostHttp({
			body: null,
			pathParams: { campaignId },
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}
		toast({
			content: "💰 DMS Cost Finalized successfully",
			toastType: "success",
		});

		navigate(`/admin/campaigns/${campaignId}/campaign-metrics`);
	}

	return (
		<DialogContent className="flex max-w-2xl flex-col items-center gap-16 border-border w-full text-center text-primary py-10">
			<DialogHeader className="flex items-center gap-2 w-full ">
				<h2 className="font-semibold text-3xl text-center">
					Are you sure you want to finalize
					<br /> DMS cost?
				</h2>
				<p className="font-semibold text-center text-secondary">
					This action will finalize the cost for the DMS campaign linked to
					this Memed campaign.
				</p>
			</DialogHeader>
			<div className="flex items-center justify-center gap-5 w-full">
				<DialogClose className="">
					<Button className="bg-tertiarybuttonbg px-20 py-8 border border-border w-56 font-semibold text-[18px]">
						Cancel
					</Button>
				</DialogClose>
				<Button
					disabled={finalisingCost}
					onClick={finalizeDMSCost}
					className="bg-primarybuttonbg px-20 py-8 w-56 font-semibold text-[18px] text-primarybuttontext"
				>
					{finalisingCost ? <Spinner width={20} /> : "Finalize"}
				</Button>
			</div>
		</DialogContent>
	);
};
